/**
 * 日志埋点
 */

import store from '@/store'
import { UUID } from 'uuidjs'
import queryString from 'query-string'
import Cookies from 'js-cookie'
import { isInDesktop, deviceId, refreshId, appVersion, terminal } from '@/utils/device-detection'
// 获取神策自定义埋点的参数
export function getParams() {
  return {
    distinct_id: store.state.Detail.anonymousId, // 神策的匿名id
    tm: terminal,
    fr: getFrom()
  }
}

function log(type, params) {
  console.log(`🛎️ ${type}: ${JSON.stringify(params)}`)
}

function getUUID() {
  if (isInDesktop && refreshId) {
    return refreshId
  }
  return (UUID.genV4() + '').replace(/-/g, '')
}

export function getDeviceId() {
  if (isInDesktop && deviceId) {
    return deviceId
  }
  let deid = localStorage.getItem('chatglm-deid')
  if (deid) {
    return deid
  }
  deid = getUUID()
  localStorage.setItem('chatglm-deid', deid)
  return deid
}

export function getFrom() {
  // 页面来源
  let fr = 'default'
  const queryParsed = queryString.parse(location.search)
  if (queryParsed.source) {
    fr = queryParsed.source
  } else if (queryParsed.fr) {
    fr = queryParsed.fr
    localStorage.setItem('chatglm-fr', fr)
  } else if (localStorage.getItem('chatglm-fr')) {
    fr = localStorage.getItem('chatglm-fr')
  }
  return fr
}

export function getFfr() {
  // 页面来源
  const queryParsed = queryString.parse(location.search)
  if (queryParsed.ffr) {
    return queryParsed.ffr
  }
  return ''
}

function getAbtestId() {
  // ab测试
  let ab
  const queryParsed = queryString.parse(location.search)
  if (queryParsed.abtestid) {
    ab = queryParsed.abtestid
  } else {
    const abtestid = Cookies.get('abtestid')
    if (abtestid) {
      ab = abtestid.split('|')
    }
  }
  return ab
}

const gOptions = {
  deid: getDeviceId(),
  reid: getUUID(),
  pd: 'chatglm',
  version: '1.0.0',
  webvs: window.page_version,
  fr: getFrom(),
  ffr: getFfr() || getFrom()
}

function send(opts, retry = 0) {
  // 如果用户用户id不存在，延迟500毫秒，最多尝试3次
  if (!store?.state?.Home?.userInfo?._id && retry < 3) {
    setTimeout(() => {
      send(opts, ++retry)
    }, 500)
    return
  }
  const baseOpts = {
    asid: store?.getters['Glms/assistantId'] || '',
    tm: terminal,
    usid: store?.state?.Home?.userInfo?._id,
    t: Date.now(),
    url: window.location.href,
    vs: appVersion,
    ab: getAbtestId()
  }
  const sendParams = {
    ...baseOpts,
    ...gOptions,
    ...opts
  }
  log(
    sendParams?.bt,
    JSON.stringify({
      md: sendParams?.md,
      ct: sendParams?.ct,
      bt: sendParams?.bt
    })
  )
  const pvImg = new Image()
  const queryStr = queryString.stringify(sendParams)
  pvImg.src = `${location.protocol}//analysis.chatglm.cn/bdms/p.gif?${queryStr}`
  // pvImg.src = `${location.protocol}//localhost:9088/bdms/p.gif?${queryStr}`
}

export function sendPv(opts) {
  opts.bt = 'pv'
  // console.log('曝光埋点=========', opts)
  send(opts)
}

export function sendCl(opts) {
  opts.bt = 'cl'
  // console.log('点击埋点=========', opts)
  send(opts)
}

export function sendPf(opts) {
  opts.bt = 'pf'
  send(opts)
}
// 神策上报自定义埋点
export function sensorsTrack(event = 'QuestionClick', params) {
  window.sensors?.track(event, params)
}

export function sendCdnTime(opts) {
  // if (!opts || !opts.name) {
  //   return
  // }
  // if (opts.name.indexOf('stream_context') === -1) {
  //   return
  // }
  // try {
  //   const t = window.performance?.getEntriesByName(opts.name, 'resource')
  //   const performanceTime = t && t[0]
  //   console.log(opts.name, t)
  //   if (performanceTime && performanceTime.domainLookupEnd !== undefined) {
  //     if (performanceTime.domainLookupEnd !== 0 && performanceTime.domainLookupStart !== 0) {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_cdn',
  //         ctnm: performanceTime.domainLookupEnd - performanceTime.domainLookupStart,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     } else {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_cdn',
  //         ctnm: -1,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     }
  //     if (performanceTime.connectEnd !== 0 && performanceTime.connectStart !== 0) {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_tcp',
  //         ctnm: performanceTime.connectEnd - performanceTime.connectStart,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     } else {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_tcp',
  //         ctnm: -1,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     }
  //     if (performanceTime.responseStart !== 0 && performanceTime.requestStart !== 0) {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_request',
  //         ctnm: performanceTime.responseStart - performanceTime.requestStart,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     } else {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_request',
  //         ctnm: -1,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     }
  //     if (performanceTime.responseEnd !== 0 && performanceTime.responseStart !== 0) {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_response',
  //         ctnm: performanceTime.responseEnd - performanceTime.responseStart,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     } else {
  //       sendPv({
  //         md: 'request',
  //         ct: 'request_url_response',
  //         ctnm: -1,
  //         ctvl: opts.name,
  //         ctid: opts.eagleid,
  //         extra: opts.status
  //       })
  //     }
  //     sendPv({
  //       md: 'request',
  //       ct: 'request_url_duration',
  //       ctnm: performanceTime.duration,
  //       ctvl: opts.name,
  //       ctid: opts.eagleid,
  //       extra: opts.status
  //     })
  //   }
  // } catch (e) {}
}
